// extracted by mini-css-extract-plugin
export default {"required-display":"required-display_required-display__NXgeS"};